import { h, Component } from 'preact';
import { containerSize, DeviceVariance } from '@cube/blocks';
import style from './style';
import cx from 'classnames';
import { stockAPIStreamer } from '@os/cloudquote';
import { calcChange, formatLastTradeTime, generatePriceFormatter, getBaseCurrencyCode, percentFormatter } from '../../lib/util';
import { getGoodPrevClose } from '../../lib/util-stock-price';
import { SymbolLookup } from '@cube/finance-blocks';
import { compose } from 'recompose';
import { Text } from 'preact-i18n';

export function DeviceWrappedStockPriceBar({ ...props }) {
	return (
		<DeviceVariance
			phone={<StockPriceBar {...props} layout={'phone'} />}
			tablet={<StockPriceBar {...props} layout={'tablet'} />}
			desktop={<StockPriceBar {...props} layout={'desktop'} />}
			desktopLarge={<StockPriceBar {...props} layout={'desktop'} />}
		/>
	);
}

function routeToSymbol(quote) {
	window.location = `/finance/category/stockdetail/symbol/${quote.UniqueSymbol}`;
}

export class StockPriceBar extends Component {
	state = { quote: {} }

	onData = (data) => {
		if (data && data.rows && data.rows.length) {
			this.setState({ quote: data.rows[0] });
		}
	};

	componentWillMount() {
		let { invalidSymbol } = this.props;

		if (!invalidSymbol) {
			this.streamer = stockAPIStreamer(this.props.symbol, 'getStockPrice').on('data', this.onData);
		}
		else {
			this.setState({ quote: { Name: 'Invalid Symbol', Price: '404' } });
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.symbol !== this.props.symbol) {
			this.streamer.stream(nextProps.symbol);
		}
	}

	componentWillUnmount() {
		if (this.stream) this.streamer.end();
	}

	render({ width, layout, ...props }, { quote }) {
		if (!quote || !quote.Price) {
			return (
				<div class={cx(style.stockPriceBar, style.loading)} />
			);
		}

		let goodPrevClose = getGoodPrevClose(quote);
		props.change = calcChange(quote.Price,goodPrevClose);
		props.changeClass = props.change.class !== 'unchanged' ? style[props.change.class] : '';
		let isPhone = layout === 'phone';
		let isDesktop = layout === 'desktop';
		return (
			<div class={cx(style.stockPriceBar, props.invalidSymbol && style.invalidSymbol)}>
				<div class={cx(style.stockHeaderCont,
					isPhone && style.phone,
					width <= 680 && style.phone,
					width > 680 && style.medium,
					isDesktop && style.wide
				)}
				>
					<div class={cx(props.changeClass, style.stockHeader)}>
						<div class={style.searchCont}>
							<div class={style.search}>
								<SymbolLookup
									class={style.symbolLookup}
									onSymbolSelect={routeToSymbol}
									trackingSource="stock-details-page/symbol-lookup"
									trackingZone="finance-components"
								/>
							</div>
							{
								!props.invalidSymbol && <StockSymbol quote={quote} {...props} />
							}
						</div>
						<Stock quote={quote} {...props} />
						<LastUpdated quote={quote} {...props} />
						<LiteDisclaimer {...props} />
					</div>
				</div>
			</div>
		);
	}
}

export const Stock = ({ quote, change, changeClass, invalidSymbol, symbol }) => {
	let	priceFormatter = generatePriceFormatter(quote);

	let quotePrice = priceFormatter(quote.Price);
	let changePrice = priceFormatter(change.price, { Plus: true });

	let changePercent = percentFormatter(change.percent);
	let name = quote.Name;
	// If the symbol is a currency, swap out the 'to', e.g. 'EURO to Dollar'
	if (quote && quote.ExchangeShortName === 'Currency') {
		name = quote.Name.split(' to ');
		name.splice(1,0, <Text id="exchanges.exchangeTo" />);
	}
	return (
		<div class={style.stock}>
			<h1>{ name }</h1>
			<div class={style.priceCont}>
				<div class={style.price}>{ invalidSymbol ? symbol : quotePrice }</div>
				{
					!invalidSymbol &&
						<div class={cx(changeClass, style.changePrice)}>
							{ changePrice }
							<span class={style.changePercent}> ({ changePercent }) </span>
						</div>
				}
			</div>
		</div>
	);
};

export const StockSymbol = ({ quote }) => {
	let { ExchangeShortName: exch, ShortName: short, Symbol: sym } = quote;
	let name = short || sym;
	if (exch === 'Currency'){
		// Convert 'Currency' as it's not a proper name like the other exchanges
		exch = <Text id={`exchanges.exchangeLong.${exch}`} />;
		// e.g. 'USD to EUR' -> 'USD a EUR'
		name = short.split(' to ');
		name.splice(1,0, <Text id="exchanges.exchangeTo" />);
	}
	return (
		<div class={style.stockSymbol}>
			<div class={style['symbol-id']}>{exch}: <span>{ name }</span></div>
		</div>
	);
};

export const LastUpdated = ({ quote, invalidSymbol, ...props }) => {
	let currency = getBaseCurrencyCode(quote);

	return (
		<p class={cx(style.lastUpdated, props.class)}>
			{
				invalidSymbol ? <Text id="SYMBOL_NOT_FOUND">This symbol cannot be found. Please try another search!</Text> :
					currency ?
						<div>
							<Text id="LAST_UPDATED_CURRENCY" fields={{ time: formatLastTradeTime(quote.LastTradeTime), currency }} />
							<a href={`/finance/disclaimer`} target="_blank" rel="noopener noreferrer">
								<Text id="DISCLAIMER">Disclaimer</Text>
							</a>
						</div>
						:
						<div>
							<Text id="LAST_UPDATED" fields={{ time: formatLastTradeTime(quote.LastTradeTime) }} />
							<a href={`/finance/disclaimer`} target="_blank" rel="noopener noreferrer">
								<Text id="DISCLAIMER">Disclaimer</Text>
							</a>
						</div>
			}
		</p>
	);
};

export const LiteDisclaimer = ({ liteMenus=false, ...props }) => {
	if (liteMenus)
		return (
			<p class={cx(style.liteDisclaimer, props.class)}>
				<div><Text id="LITE_DISCLAIMER" /></div>
			</p>
		);
};

export default compose(
	containerSize({ height: false })
)(DeviceWrappedStockPriceBar);



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-price-bar/index.js